(() => {
  function smWishList() {
    const visitProductBtn = qsa('.addbutton.addsingleproduct');
    if(visitProductBtn) {
      clearInterval(checkInterval);
      const url = window.location.pathname.split('/'); // Get the locale
      visitProductBtn.forEach(item => {
        const currentUrl = item.dataset.url;
        if(currentUrl.indexOf(url[1]) <= 0) {
          item.dataset.url = `/${url[1]}${currentUrl}`;
        }
      })
    }
  } 

  function moveBackInStock() {
    const backInForm = qs('.restock-alerts-form');
    if(backInForm) {
      const addButtonWrap = qs('.main-product__checkout-buttons');
      const backMainForm = qs('.main-product__checkout-buttons .restock-alerts-form');
      if(backMainForm) {
        addButtonWrap && addButtonWrap.insertAdjacentElement('afterEnd', backMainForm);
        clearInterval(backInInterval);
      }
    }
  }
  
  var backInInterval = setInterval(moveBackInStock, 500);
  var checkInterval = setInterval(smWishList, 1000);
})();